import { createApolloClientWithCache } from 'src/scripts/templates/_shared/apolloClientUtils';

export const CartApolloClient = createApolloClientWithCache();
